import { toast } from "react-toastify";
import { ApiClient } from "./api/client";
import { processResponse } from "./api/helpers";


export const downloadFileFromUrl = async (url: string | Promise<Blob>, downloadAs: string, createImageWithBlobInstead = false) => {
    let resultURL = await (typeof url == 'string' ? (await fetch(url as string)).blob() : (url as Promise<Blob>))
    if (!createImageWithBlobInstead) {
        const href = window.URL.createObjectURL(resultURL);
        let anchor = document.createElement('a')
        anchor.setAttribute('href', href)
        anchor.setAttribute('download', downloadAs)
        anchor.style.display = 'none'
        document.body.appendChild(anchor)
        anchor.click()
        window.URL.revokeObjectURL(href);
        return {}
    } else {
        const data = [window.URL.createObjectURL(resultURL)]
        return { data, error: null, list: data } as api_res_t<string[]>;
    }
}

export const downloadFileFromBackend = async (url: string, saveAs: string, params = {}, createImageBlobInstead = false, postData = null as any) => {
    let data: any, error: any = null
    if (postData)
        ({ data, error } =  processResponse(await ApiClient.post(url, postData, { params, responseType: 'blob' })));
    else ({ data, error } = processResponse(await ApiClient.get(url, { params, responseType: 'blob' })));

    return data && !error ? downloadFileFromUrl(data as any, saveAs, createImageBlobInstead) : { error: `${error}`,data:null }
}